import getDevSidebar from '../../customApp/sidebar'; // changing name from devSideBar to options
const options = [
  ...getDevSidebar
];
export default options;
